import { css } from "@emotion/react";

import { colors, dimensions } from "@styles";

export const footer = css`
  width: 100%;
  background: white;
  flex-shrink: 0;
  margin-top: 1rem;
`;

export const topBorder = css`
  border-top: 1px solid ${colors.grey.lightFamily.normal};
`;

export const mobileWrapper = css`
  display: flex;
  flex-direction: column;
`;

export const wrapper = css`
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;

  @media (max-width: ${dimensions.tabletMax}) {
    flex-direction: column;
    padding: 0;
  }
`;
